import { Button } from "@heroui/react";
import { Icon } from "@iconify/react";
import { FEATURE_FLAGS } from "@onesolution/constants";

import { useClientInfos, useLanguage } from "@onesolution/hooks";

export default function EmptyContent({
	onCreateOperationClick,
	resetFilters,
}: { onCreateOperationClick?: () => void; resetFilters?: () => void }) {
	const { t } = useLanguage();
	const clientInfos = useClientInfos();

	return (
		<div className="flex flex-col items-center justify-center size-full gap-4">
			<span className="font-bold text-2xl">{t("operation.empty-now")}</span>
			<span className="text-sm">{t("operation.create-first")}</span>
			<div className="flex gap-4">
				{onCreateOperationClick &&
					!clientInfos?.disabledFeatures.includes(
						FEATURE_FLAGS.createOperation,
					) && (
						<Button
							variant="solid"
							color="primary"
							onPress={onCreateOperationClick}
							startContent={
								<Icon icon="solar:add-circle-bold" className="size-5" />
							}
						>
							{t("basic.create")} {t("name.operation")}
						</Button>
					)}
				{resetFilters && (
					<Button
						variant="solid"
						color="primary"
						onPress={resetFilters}
						startContent={
							<Icon icon="solar:filter-bold-duotone" className="size-5" />
						}
					>
						{t("basic.reset-filters")}
					</Button>
				)}
			</div>
		</div>
	);
}
